export default debug => {
  /**
   * Logs a message if debug is enabled.
   */
  return function () {
    if (debug) {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      console.log('[Penpal]', ...args); // eslint-disable-line no-console
    }
  };
};